﻿@if (gridRows) {
  <div id="rdo-grid">
    <div class="ui-table-missing-scrollable-header"></div>
    <p-table
      #rdoExpandedGrid
      [value]="gridRows"
      [dataKey]="dataKey"
      [styleClass]="'rdo-ui-table'"
      [rowHover]="false"
      [sortMode]="'single'"
      [sortField]="sorting.sortField"
      [sortOrder]="sorting.sortOrder"
      [scrollable]="true"
      [scrollHeight]="scrollHeight"
      [frozenValue]="frozenGridRows"
      [frozenWidth]="frozenWidth"
      [columns]="scrollableColumns"
      [frozenColumns]="frozenColumns"
      [customSort]="true"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      (onRowExpand)="onRowExpand && onRowExpand($event.data)"
      (onRowCollapse)="onRowCollapse($event.data)"
      (onSort)="changeSort($event)"
      >
      <ng-template #breadcrumbActions>
        @if (showColumnSelector && !useProductTypeColumnSelector && !useConfiguredColumnSelector) {
          <rdo-column-selector
            [size]="'md'"
            [gridConfig]="columnSelectorConfig"
            (visibilityChanged)="saveGridLayout()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector>
        }
        @if (showColumnSelector && useProductTypeColumnSelector) {
          <rdo-column-selector-product-type
            [size]="'md'" [gridConfig]="columnSelectorConfig" (visibilityChanged)="saveGridLayout()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector-product-type>
        }
        @if (useConfiguredColumnSelector) {
          <rdo-configured-column-selector
            [size]="'md'"
            [gridConfig]="columnSelectorConfig"
            (visibilityChanged)="saveGridLayout()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)"
            >
          </rdo-configured-column-selector>
        }
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <colgroup>
            <col [style.width]="getWidthStyle(column)" />
          </colgroup>
        }
      }
    </ng-template>
    <!-- top header row -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (group of columns; track group) {
          <th
            [style.width]="getColGroupWidth(group)"
            [attr.colspan]="group.columns.length"
            [class.expandable]="group.expandable"
            [class.group-end]="isGroupEnd(group)"
            id="{{group.title | rdoPathToId}}"
            [ngStyle]="group.headerStyle"
            >
            <div data-toggle="tooltip" htmlTooltip="{{getGroupTooltip(group)}}"
              [attr.title]="getGroupTooltip(group) ? null : translate(group.title)">{{translate(group.title)}}
            </div>
            <!-- From non expandable... -->
            <!-- *ngIf="(!group.forceCanClose !== false && group.locked || group.forceCanClose) && (group.text || group.columns.length > 1)" -->
            @if (!group.locked && group.columns.length > 1) {
              <a (click)="toggleColumnVisibility(group)"
                title="{{'main.core.tables.common.hide_column_group' | translate}}">
                <span class="fa fa-lg fa-times-circle pull-right"></span>
              </a>
            }
          </th>
        }
      </tr>
      <!-- second header row -->
      <tr style="height: 38px;">
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let columnIndex = $index) {
            <th
              id="{{column.sortColumn}}"
              [pSortableColumn]="filterSortableColumns(column)"
              [ngStyle]="column.headerStyle"
              [style.width.px]="column.width"
              [class.group-end]="isHeaderGroupEnd(group, column)"
              [attr.data-maxWidth]="getColumnMaxWidth(column)"
              [attr.data-minWidth]="column.minWidth"
              class="ellipsed-th allow-overflow make-relative"
              >
              <rdo-movable-column-arrows
                [column]="column"
                [gridConfig]="gridConfig"
                [onMove]="moveColumn"
                >
                <!-- close button -->
                @if (column.isClosable) {
                  <a
                    (click)="toggleColumnVisibility(column)"
                    title="{{'main.core.tables.common.hide_column_group' | translate}}"
                    class="table-close-button"
                    style="position: absolute; right: -2px; top: -5px"
                    >
                    <span class="fa fa-lg fa-times-circle pull-right"></span>
                  </a>
                }
                <!-- end close button -->
                <div class="ellipsed-div" [class.header-moveable]="group.isMovable">
                  <div htmlTooltip="{{getColumnTooltip(column)}}"
                    [attr.title]="getColumnTooltip(column) ? null : translate(column.title)"
                    [attr.data-column]="translate(column.title)"
                    [ngStyle]="{'line-height': !allowDoubleHeader ? '2.9em' : 'unset' }">{{(column |
                  rdoEllipsis:column.renderedWidth).processedTitle}}</div>
                  <p-sortIcon [field]="column.sortColumn"></p-sortIcon>
                </div>
              </rdo-movable-column-arrows>
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenrows" let-rowData let-columns="columns">
      <tr class="frozen-row">
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <td
              [ngClass]="rowData[column.sortColumn].class"
              [ngStyle]="rowData[column.sortColumn].style"
              [style.width]="rowData[column.sortColumn].width"
              [class]="getHeaderClass(column)"
              [class.group-end]="isCellGroupEnd(group, column)"
              id="header-{{column.sortColumn}}-cell"
              title="{{handleValue(rowData[column.sortColumn].value)}}"
              >
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  [routerLink]="rowData[column.sortColumn].linkDsl"
                >{{rowData[column.sortColumn].value |translate}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  href="{{rowData[column.sortColumn].href}}"
                >{{rowData[column.sortColumn].value | translate}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                <span id="header-{{column.sortColumn}}-cell-text"
                >{{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <!-- render the rows in the frozen part of grid -->
    <ng-template pTemplate="frozenbody" let-rowData let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr [class.clickable-row]="!disableExpandability && rowData.isExpandable"
        (mouseenter)="onMouseEnter(rowData, false, 'frozen')"
        (mouseleave)="onMouseLeave(rowData, false, 'frozen')"
        [pRowToggler]="rowData" [class.row-hover]="rowData.hover">
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let columnIndex = $index) {
            @if (columnIndex === 0) {
              <td
                id="detail-{{column.sortColumn}}-{{rowIndex}}"
                [ngClass]="rowData[column.sortColumn].class"
                [ngStyle]="rowData[column.sortColumn].style"
                [style.width]="rowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(rowData[column.sortColumn].value)}}">
                <!-- TODO: Hide the carat and disable the click when the column shouldn't be expandable -->
                @if (!rowData.childLoading && !disableExpandability && rowData.isExpandable) {
                  <i
                    [ngClass]="rowData.expanded ? 'fa fa-fw fa-angle-down' : 'fa fa-fw fa-angle-right'">
                  </i>
                }
                @if (!rowData.childLoading && !disableExpandability && !rowData.isExpandable) {
                  <span
                    [ngClass]="'non-expandable-spacer'">
                  </span>
                }
                @if (rowData.childLoading) {
                  <i class="fa fa-fw fa-circle-o-notch fa-spin"></i>
                }
                @if (!rowData[column.sortColumn].href) {
                  <span>{{rowData[column.sortColumn].value}}</span>
                }
                @if (rowData[column.sortColumn].href) {
                  <a
                    (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value}}</a>
                }
              </td>
            }
            @if (columnIndex !== 0) {
              <td
                id="detail-{{column.sortColumn}}-{{rowIndex}}"
                [ngClass]="rowData[column.sortColumn].class"
                [ngStyle]="rowData[column.sortColumn].style"
                [style.width]="rowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(rowData[column.sortColumn].value)}}"
                >
                @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                  <i
                  class="fa fa-check"></i>
                }
                @if (rowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  [routerLink]="rowData[column.sortColumn].linkDsl">{{rowData[column.sortColumn].value}}</a>
                }
                @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value}}</a>
                }
                @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                  <span
                  >{{rowData[column.sortColumn].value}}</span>
                }
              </td>
            }
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex" let-columns="columns" let-rowIndex="rowIndex">
      <tr [class.clickable-row]="!disableExpandability && rowData.isExpandable"
        (mouseenter)="onMouseEnter(rowData, false,  'body')"
        (mouseleave)="onMouseLeave(rowData, false, 'body')"
        [pRowToggler]="rowData" [class.row-hover]="rowData.hover">
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <td id="detail-{{column.sortColumn}}-{{index}}"
              [ngClass]="rowData[column.sortColumn].class"
              [ngStyle]="rowData[column.sortColumn].style"
              [style.width]="rowData[column.sortColumn].width"
              [class.group-end]="isCellGroupEnd(group, column)"
              title="{{handleValue(rowData[column.sortColumn].value)}}"
              >
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                [routerLink]="rowData[column.sortColumn].linkDsl">{{translate(rowData[column.sortColumn].value)}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                href="{{rowData[column.sortColumn].href}}">{{translate(rowData[column.sortColumn].value)}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                <span
                >{{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" let-rowData let-index="rowIndex" let-rowIndex="rowIndex">
      @for (childRowData of rowData.childRows; track childRowData) {
        <tr class="expansion-row"
          (mouseenter)="onMouseEnter(childRowData, true, 'rowexpansion')" (mouseleave)="onMouseLeave(childRowData, true, 'rowexpansion')"
          [class.row-hover]="childRowData.hover">
          @for (group of columns; track group) {
            @for (column of group.columns; track column) {
              <td
                id="detail-{{column.sortColumn}}-{{rowIndex}}"
                [ngClass]="childRowData[column.sortColumn].class"
                [ngStyle]="childRowData[column.sortColumn].style"
                [style.width]="childRowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(childRowData[column.sortColumn].value)}}">
                @if (!childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl && isBool(childRowData[column.sortColumn].value) && childRowData[column.sortColumn].value) {
                  <i
                  class="fa fa-check"></i>
                }
                @if (childRowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(childRowData[column.sortColumn].config, childRowData.raw, rowData.raw)"
                  [routerLink]="childRowData[column.sortColumn].linkDsl">{{translate(childRowData[column.sortColumn].value)}}</a>
                }
                @if (childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(childRowData[column.sortColumn].config, childRowData.raw, rowData.raw)"
                  href="{{childRowData[column.sortColumn].href}}">{{translate(childRowData[column.sortColumn].value)}}</a>
                }
                @if (!childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl && !isBool(childRowData[column.sortColumn].value)) {
                  <span
                  >{{translate(childRowData[column.sortColumn].value)}}</span>
                }
              </td>
            }
          }
        </tr>
      }
    </ng-template>
  </p-table>
  <p-paginator
    #gridPaginator
    id="gridPaginator"
    styleClass="rdo-paginator"
    [(first)]="paging.first"
    [rowsPerPageOptions]="[10,20,50]"
    [pageLinkSize]="10"
    [rows]="paging.pageSize"
    [totalRecords]="totalCount"
    (onPageChange)="onPage($event)"
    [alwaysShow]="alwaysShowPager"
    />
</div>
}
